import {Injectable} from "@angular/core";
import {CanadianCurrencyCode} from "../../../objects/currencyExchange/canadianCurrencyCode";
import {BaseResponse} from "../../../objects/common/baseResponse";
import {CurrencyService} from "../../../services/currencyService";
/**
 * Created by vlad.p on 8/22/2017.
 */

@Injectable()
export class CanadianCurrencyCodesResolver {

    constructor(private currencyService: CurrencyService) {
    }

    public resolve(): Promise<BaseResponse<CanadianCurrencyCode[]>> {

        return this.currencyService.getCanadianCurrencyCodes();
    }

}


// WEBPACK FOOTER //
// ./app/components/calculator/resolvers/canadian-currency-codes.resolver.ts